import { AssetAssetCaseAttributes } from '@/types'
import { AddAssetToCaseMutation } from './__generated__/add_asset_mutation'
import { Mutation as AddMutation } from './add_asset_mutation'
import { useForm } from '@/helpers/useForm'
import { Query as TableQuery } from '@/components/asset/table_query'

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<AddAssetToCaseMutation, AssetAssetCaseAttributes, never, never>({
    id,
    defaultValues: {
      barcode: ''
    },
    mutation: AddMutation,
    resultKey: 'addAssetToCase',
    refetchQueries: [TableQuery]
  })

  return (
    <>
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Add an asset by barcode', field: 'barcode', type: 'text' }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess, 'Add asset to case') }
      </div>
    </>
  )
}
